import { IBaseReducer } from 'models/IBaseReducer';
import { IResponse, IResultTrends, IRound } from './ResultPagesInterfaces';
import { GroupingType, IResultService, IStatisticItem } from './ICommon';

export interface IHeatmapStatistic {
	locationStatistic: IStatisticItem[];
	roleStatistic: IStatisticItem[];
	businessUnitStatistic: IStatisticItem[];
}

export interface IMetricSatisfaction {
	value: number;
	trend: number;
}

export interface INamedMetricSatisfaction extends IMetricSatisfaction {
	name: string;
}

export interface IMetricSatisfactionForFilter {
	best: INamedMetricSatisfaction;
	worst: INamedMetricSatisfaction;
}

export interface ISummaryResponses {
	count: number;
	rate: number;
}

export enum ScoreTypes {
	countries = 'countries',
	businessUnits = 'businessUnits',
	services = 'services',
}

export interface IMetricsSatisfaction
	extends Partial<Record<ScoreTypes, IMetricSatisfactionForFilter>> {
	overall: IMetricSatisfaction;
}

export interface ISummaryMetrics {
	accuracy: number;
	responses: ISummaryResponses;
	satisfaction: IMetricsSatisfaction;
}

export interface ISummaryErrors {
	rounds?: boolean;
	serviceCards?: boolean;
	heatmap?: boolean;
	services?: boolean;
	metrics?: boolean;
	logo?: boolean;
}

export interface ISummaryReducer extends IBaseReducer, IHeatmapStatistic {
	isAllPageLoading: boolean;
	rounds: IRound[];
	activeRound?: IRound;
	surveyName?: string;
	isSurveyQuick?: boolean;
	serviceTrends: IResultTrends[];
	services: IResultService[];
	clientLogoUrl?: string;
	clientName?: string;
	metrics?: ISummaryMetrics;
	errors?: ISummaryErrors;
}

export interface ISummaryPayload {
	surveyId: string;
	roundId: string;
}

export interface IHeatmapPayload extends ISummaryPayload {
	groupingType: GroupingType;
}

export interface ISummaryRoundsAndSurveyName {
	rounds: IRound[];
	activeRound: IRound;
	surveyName: string;
	isSurveyQuick: boolean;
}

export interface ISummaryClientData {
	id: string;
	name: string;
	logoUrl: string;
}

export interface IResponseMetric extends IResponse {
	content: ISummaryMetrics;
}

export interface IResponseClient extends IResponse {
	content: ISummaryClientData;
}
